import { render, staticRenderFns } from "./Selection.vue?vue&type=template&id=61b239aa&scoped=true&"
import script from "./Selection.vue?vue&type=script&lang=js&"
export * from "./Selection.vue?vue&type=script&lang=js&"
import style0 from "./Selection.vue?vue&type=style&index=0&id=61b239aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b239aa",
  null
  
)

export default component.exports